const { queryStorepageRootElement } = require('./queryElement');

/**
 * Get the ID associated to a store page (Page Designer)
 * @returns {string} ID of the store page
 */
const getStorePageId = () => queryStorepageRootElement()?.id ?? null;

module.exports = {
    getStorePageId
};
